module.exports = __webpack_public_path__ + "static/media/lg-klima-projekmenedzsment.00f50837.jpg";